export default {
  title: {
    management: 'Job Application Management',
    invitation: 'Job Application Invitation',
    question: {
      add: 'Add New Question',
      edit: 'Edit Question'
    },
    step: {
      add: 'Add New Step',
      edit: 'Edit Step'
    },
    questionnaire: {
      add: 'Add New Questionnaire',
      edit: 'Edit Questionnaire'
    },
    microSite: {
      add: 'Add New Microsite',
      edit: 'Edit Microsite'
    },
    emailTemplate: {
      add: 'Add New Email Template',
      edit: 'Edit Email Template'
    },
    iconSelector: 'Select Icon',
    questionSelector: 'Select Question',
    stepSelector: 'Select Step'
  },
  menu: {
    management: 'Job Application Management',
    invitation: 'Job Application Invitation'
  },
  tabMenu: {
    microSite: 'Microsite',
    questionnaire: 'Survey Template',
    step: 'Step',
    question: 'Question',
    emailTemplate: 'Email Template'
  },
  questionType: {
    text: 'Text',
    date: 'Date',
    single: 'Single Selector',
    multiple: 'Multiple Selector',
    attachment: 'Attachment',
    link: 'Agreement Link',
    location: 'Location',
    country: 'Country/Region',
    province: 'Province',
    city: 'City',
    nationality: 'Nationality',
    language: 'Language',
    nps: 'NPS',
    stars: 'Stars Rating Question',
    signature: 'Handwritten Signature'
  },
  questionnaireType: {
    general: 'Manually Triggered Survey'
  },
  language: {
    cn: 'Simplified Chinese',
    tc: 'Traditional Chinese',
    en: 'English'
  },
  label: {
    question: 'Question',
    questionName: 'Question Name',
    questionType: 'Question Type',
    questionStatus: 'Question Status',
    questionOption: 'Question Option',
    questionConfig: 'Question Config',
    prefillSource: 'Prefill Source',
    dateFormat: 'Date Format',
    minRows: 'Minimum Rows',
    maxRows: 'Maximum Rows',
    addButtonText: {
      cn: 'Add Button Text (Simplified Chinese)',
      tc: 'Add Button Text (Traditional Chinese)',
      en: 'Add Button Text (English)'
    },
    subFields: 'Sub Fields',
    subFieldNo: 'Sub Field {number}',
    subFieldKey: 'Field Key',
    subFieldType: 'Field Type',
    subFieldTypeText: 'Text',
    subFieldTypeDateRange: 'Date Range',
    subFieldTypeSingle: 'Single Selector',
    required: 'Required',
    width: 'Width',
    subFieldLabel: {
      cn: 'Label (Simplified Chinese)',
      tc: 'Label (Traditional Chinese)',
      en: 'Label (English)'
    },
    subFieldPlaceholder: {
      cn: 'Placeholder (Simplified Chinese)',
      tc: 'Placeholder (Traditional Chinese)',
      en: 'Placeholder (English)'
    },
    linkText: {
      cn: 'Agreement Text (Simplified Chinese)',
      tc: 'Agreement Text (Traditional Chinese)',
      en: 'Agreement Text (English)'
    },
    linkUrl: {
      cn: 'Agreement Link (Simplified Chinese)',
      tc: 'Agreement Link (Traditional Chinese)',
      en: 'Agreement Link (English)'
    },
    checkboxLabel: {
      cn: 'Checkbox Text (Simplified Chinese)',
      tc: 'Checkbox Text (Traditional Chinese)',
      en: 'Checkbox Text (English)'
    },
    optionNo: 'Option {number}',
    step: 'Step',
    stepName: 'Step Name',
    stepIcon: 'Step Icon',
    stepStatus: 'Step Status',
    isRequiredQuestion: 'Required Question',
    questionnaireName: 'Questionnaire Name',
    questionnaireStatus: 'Questionnaire Status',
    questionnaireType: 'Questionnaire Type',
    scope: 'Questionnaire Type',
    micrositeName: 'Microsite Name',
    micrositeTitle: 'Title',
    micrositeUrl: 'Preview Link',
    micrositeIsFinished: 'Finish Design',
    micrositeStatus: 'Status',
    emailSubject: 'Email Subject',
    emailType: 'Email Type',
    microsite: 'Microsite',
    invitationDate: 'Invitation Date',
    postApplicantDate: 'Complete Date',
    export: 'Export',
    recruiter: 'Recruiter',
    operation: 'Action',
    questionnaire: 'Questionnaire',
    candidate: 'Candidate',
    company: 'Company',
    job: 'Job',
    status: 'Status',
    finished: 'Finished',
    unfinished: 'Unfinished',
    keywordsSearch: ' Keywords search',
    noticeSuccessMessage: 'The candidate has been successfully reminded',
    operationBtn: {
      notice: 'Remind',
      cancel: 'Cancel',
      view: 'View',
      reactivate: 'Reactivate',
      exportPdf: 'Download PDF'
    },
    statusList: {
      all: 'All Status',
      invited: 'Invited',
      finished: 'Finished',
      cancelled: 'Cancelled'
    },
    title: {
      cn: '@:admin.company.jobApplication.language.cn标题',
      tc: '@:admin.company.jobApplication.language.tc标题',
      en: '@:admin.company.jobApplication.language.en标题'
    },
    name: {
      cn: '@:admin.company.jobApplication.language.cn Name',
      tc: '@:admin.company.jobApplication.language.tc Name',
      en: '@:admin.company.jobApplication.language.en Name',
      country: {
        cn: 'Country/Region @:admin.company.jobApplication.language.cn Name',
        tc: 'Country/Region @:admin.company.jobApplication.language.tc Name',
        en: 'Country/Region @:admin.company.jobApplication.language.en Name'
      },
      province: {
        cn: 'Province @:admin.company.jobApplication.language.cn Name',
        tc: 'Province @:admin.company.jobApplication.language.tc Name',
        en: 'Province @:admin.company.jobApplication.language.en Name'
      },
      city: {
        cn: 'City @:admin.company.jobApplication.language.cn Name',
        tc: 'City @:admin.company.jobApplication.language.tc Name',
        en: 'City @:admin.company.jobApplication.language.en Name'
      }
    },
    placeholder: {
      cn: '@:admin.company.jobApplication.language.cn Placeholder',
      tc: '@:admin.company.jobApplication.language.tc Placeholder',
      en: '@:admin.company.jobApplication.language.en Placeholder',
      country: {
        cn: 'Country/Region @:admin.company.jobApplication.language.cn Placeholder',
        tc: 'Country/Region @:admin.company.jobApplication.language.tc Placeholder',
        en: 'Country/Region @:admin.company.jobApplication.language.en Placeholder'
      },
      province: {
        cn: 'Province @:admin.company.jobApplication.language.cn Placeholder',
        tc: 'Province @:admin.company.jobApplication.language.tc Placeholder',
        en: 'Province @:admin.company.jobApplication.language.en Placeholder'
      },
      city: {
        cn: 'City @:admin.company.jobApplication.language.cn Placeholder',
        tc: 'City @:admin.company.jobApplication.language.tc Placeholder',
        en: 'City @:admin.company.jobApplication.language.en Placeholder'
      }
    },
    agreementLink: {
      cn: '@:admin.company.jobApplication.language.cn Agreement Link',
      tc: '@:admin.company.jobApplication.language.tc Agreement Link',
      en: '@:admin.company.jobApplication.language.en Agreement Link'
    },
    agreementText: {
      cn: '@:admin.company.jobApplication.language.cn Agreement Text',
      tc: '@:admin.company.jobApplication.language.tc Agreement Text',
      en: '@:admin.company.jobApplication.language.en Agreement Text'
    }
  },
  placeholder: {
    searchKeyword: {
      question: 'Please enter question name',
      step: 'Please enter step name'
    },
    questionnaireName: 'Please enter questionnaire name',
    step: 'Please select step',
    stepName: 'Please enter step name',
    question: 'Please select Question',
    questionName: 'Please enter question name',
    questionType: 'Please select question type',
    questionConfig: 'Please enter question config JSON',
    prefillSource: 'Please select prefill source',
    linkText: 'Please enter agreement text',
    linkUrl: 'Please enter agreement link',
    subFieldKey: 'Please enter field key',
    width: 'Please enter width, e.g. 180px',
    subFieldLabel: 'Please enter sub-field label',
    subFieldPlaceholder: 'Please enter sub-field placeholder',
    agreementLink: 'Please enter agreement link',
    placeholder: 'Please enter question placeholder',
    optionName: 'Please enter option name',
    questionnaireType: 'Please select questionnaire type',
    emailSubject: 'Please enter email subject',
    emailTemplate: 'Please enter email template',
    micrositeName: 'Please enter micro site name',
    selectMicrositeName: 'Please select micro site'
  },
  message: {
    questionNameRequired: 'Please enter question name',
    questionTypeRequired: 'Please select question type',
    questionConfigInvalid: 'Question config is not valid JSON',
    maxRowsInvalid: 'Maximum rows cannot be less than minimum rows',
    subFieldRequired: 'Please complete field key, field type, and labels for all languages',
    subFieldTypeUnsupported: 'Single selector sub-fields are not supported in this version',
    agreementTextRequired: 'Please enter agreement text',
    agreementLinkRequired: 'Please enter agreement link',
    optionNameRequired: 'Please enter option name',
    stepNameRequired: 'Please enter step name',
    stepQuestionsRequired: 'Please select Question',
    NPSQuestionSingle: 'Only one NPS question per question',
    stepIconRequired: 'Please select step icon',
    questionnaireStepsRequired: 'Please select step',
    questionnaireMicroSiteRequired: 'Please select microsite',
    NPSStepSingle: 'Only one NPS question per question',
    signatureQuestionSingle: 'Only one handwritten signature question is allowed per job application form',
    questionnaireNameRequired: 'Please enter questionnaire name',
    questionnaireTypeRequired: 'Please select questionnaire type',
    scopeRequired: 'Please select questionnaire type',
    emailSubjectRequired: 'Please enter email subject',
    emailTemplateRequired: 'Please enter email template',
    emailTemplateTip: {
      warn: `
        The editor below supports placeholders such as <span class="strong">{{first_name}}</span>. They will be replaced when a real job application invitation is sent.
        <br/>
        Please do <span class="strong">not</span> change placeholder names. You may adjust the surrounding text or QR code style.
      `,
      description: `
        <tr>
          <th>Placeholder</th>
          <th>Value / Description</th>
        </tr>
        <tr>
          <td>{{questionnaire_page_link}}</td>
          <td>Job application questionnaire link</td>
        </tr>
        <tr>
          <td>{{job_application_page_qrcode}}</td>
          <td>QR code for the job application questionnaire link. The QR code opens the questionnaire link.</td>
        </tr>
        <tr>
          <td>{{first_name}}</td>
          <td>First name of invited candidate</td>
        </tr>
        <tr>
          <td>{{last_name}}</td>
          <td>Last name of invited candidate</td>
        </tr>
        <tr>
          <td>{{hr_first_name}}</td>
          <td>First name of HR</td>
        </tr>
        <tr>
          <td>{{hr_last_name}}</td>
          <td>Last name of HR</td>
        </tr>
        <tr>
          <td>{{candidate_profile_link}}</td>
          <td>Page link of candidate profile</td>
        </tr>
        <tr>
          <td>{{questionnaire_page_qrcode}}</td>
          <td>Event QR code</td>
        </tr>
      `
    },
    testEmailHasSent: 'Test email send success!'
  },
  microsite: {
    pcOrMobile: 'PC/Mobile',
    micrositeName: 'Microsite Name',
    micrositeLink: 'Microsite Link',
    webEnLink: 'Web (English)',
    webCnLink: 'Web (Chinese)',
    webTcLink: 'Web (Traditional Chinese)',
    mobileEnLink: 'Mobile (English)',
    mobileCnLink: 'Mobile (Chinese)',
    mobileTcLink: 'Mobile (Traditional Chinese)'
  },
  headerImage: {
    tipMessage: {
      pc: 'Recommended Size is: 1920*750 ( < 5MB )',
      mobile: 'Recommended Size is: 750*1100 ( < 5MB )'
    }
  }
}
